export const sourceUrl = 'https://restcountries.com/v3.1/';
export const wikiSearch = 'https://en.wikipedia.org/wiki/Special:Search/';
